import { Request } from "../Request";
import { BASE_URL } from "../../constants/urls";

export const saveCasino = async (data: any) => {
  return Request.post("/casino", { data: data });
};

export const getCasino = async (id: any) => {
  return Request.get(`/casino/${id}`, {});
};

export const getCount = async () => {
  return Request.get(`/casinos/get-count`, {});
};

export const getCasinoDetails = async (id: any) => {
  return Request.get(`/casinos/get-casino/${id}`, { noAuth: true });
};

export const getAll = async () => {
  return Request.get(`/casino`, {});
};

export const getActive = async () => {
  return Request.get(`/casinos/get-active`, { noAuth: true });
};

export const deleteCasino = async (id: any) => {
  return Request.del(`/casino/${id}`, {});
};

export const updateCasino = async (id: any, data: any) => {
  return Request.put(`/casino/${id}`, { data: data });
};

export async function uploadImage(image: File) {
  const formData = new FormData();
  formData.append("image", image);
  try {
    const response = await fetch(`${BASE_URL}/media`, {
      method: "POST",
      body: formData,
    });

    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      alert("Something went wrong! Try Again.");
    }
  } catch (error) {
    alert("Something went wrong! Try Again.");
  }
}
